<icc-list
    [items]="colors"
    [searchable]="true"
    [itemTemplate]="'itemColor'"
    (select)="selectColor($event)"
    [tabs]="colorGroups"
    [selected]="selectedId"
></icc-list>

